import { useMemo } from 'preact/hooks'

import { checkConditions } from '@/components/helpers/metaobjects'

/**
 * Takes a criteria object to pass to checkConditions to validate what badges should display.
 * Returns at most 2 badges, highest priority first.
 */

export function useBadges(criteria) {
  return useMemo(() => {
    const data = GM_STATE.metaobjects.badges
    return data
      .filter((badge) => checkConditions(badge.conditions, criteria))
      .sort((a, b) => (a.conditions?.priority ?? 99999) - (b.conditions?.priority ?? 99999))
      .slice(0, 2)
  }, [])
}
